export const User = {
    id: '',
    email: '',
    password: '',
    fullName: '',
    role: '',
    status: 0,
    isDeleted: false
}